import { Injectable } from '@angular/core';
import * as apiUrl from '../constants/api-urls';
import { environment as ENV } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { Observable, catchError, retry, throwError } from 'rxjs';
import * as constant from './../constants/constants'

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient, private authService: MsalService) { }
  api_url = `${ENV.API_ENDPOINT}`;

  // /** Get The User Details */
  // getUserDetails() {
  //   let url = this.api_url + 'userDetails/'
  //   return this.http.get(url)
  // }

  getUserDetails(): Observable<any> {
    return this.http
      .get<any>(this.api_url + apiUrl.dashboard.getUserDetails)
      .pipe(catchError(this.handleError));
  }


  getRoleBasedFeatures(payload:any){
    let url = this.api_url + apiUrl.dashboard.featureApi
    return this.http.post(url, payload)
  }

  getConfiguration(){
    let url = this.api_url + apiUrl.dashboard.configuration
    return this.http.get(url)
  }

   // Error handling
   handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }

  getApiKeys(){
    return this.http
    .get<any>(this.api_url + apiUrl.dashboard.getApiKeys,{headers: new HttpHeaders().set(constant.common.skip_market, 'true')})
    .pipe(catchError(this.handleError));
  }
  
}
